export default (graphComponentRef, renderingManager) => () => {
    var _a;
    (_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.selection.selectedNodes.toArray().forEach(node => {
        var _a;
        renderingManager.setWebGL2NodeStyle(node, false, false, false);
        (_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.graph.remove(node);
    });
};
